import styled from "styled-components";
import {ModalContentContainer} from "../../atoms/modal/modal.styles.js";
export const CropImageContainer = styled.div.withConfig({
  displayName: "crop-imagestyles__CropImageContainer",
  componentId: "sc-jdkzis-0"
})(["", "{", "}"], ModalContentContainer, {
  display: "flex",
  justifyContent: "center",
  verticalAlign: "middle",
  alignItems: "center"
});
